import { Link } from "react-router-dom";
import { ArrowRight, Users, Layers, ShieldCheck, Briefcase, Mail } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { InnerBlock } from "@/components/InnerBlock";
import { InnerCTA } from "@/components/InnerCTA";

const LINKS = [
  { to: "/company/about-us", icon: Users, title: "About us", desc: "An Oman-based technology company that runs its own products." },
  { to: "/company/how-we-work", icon: Layers, title: "How we work", desc: "Discovery, fixed scope, two-week sprints, written SLA." },
  { to: "/company/pdpl-compliance-oman", icon: ShieldCheck, title: "PDPL & compliance", desc: "What the law requires, and how we build for it from sprint one." },
  { to: "/company/careers", icon: Briefcase, title: "Careers", desc: "Build things that run in the real world." },
  { to: "/company/contact", icon: Mail, title: "Contact", desc: "Talk to an engineer, not a call centre." },
];

export default function CompanyIndex() {
  return (
    <div data-testid="company-index">
      <Seo title="Company — Wafa Solutions" description="An Oman-based technology company, and the technology partner to Altalib Group." />
      <PageHero
        eyebrow="Company"
        h1="Company"
        intro="An Oman-based technology company, and the technology partner to Altalib Group. We build software for clients and run our own platforms."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Company" }]}
      />
      <InnerBlock tint="white">
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {LINKS.map(({ to, icon: Icon, title, desc }) => (
            <Link key={to} to={to} data-testid={`company-link-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_18px_40px_-20px_rgba(14,79,58,0.25)]">
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-wafa-cream/70 text-wafa-deep group-hover:bg-wafa-primary group-hover:text-white transition-colors"><Icon className="h-5 w-5" /></div>
              <div className="mt-5 font-heading text-lg font-semibold text-wafa-deep group-hover:text-wafa-primary">{title}</div>
              <p className="mt-2 text-sm text-wafa-ink/70">{desc}</p>
              <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-wafa-deep">Read more <ArrowRight className="h-4 w-4" /></div>
            </Link>
          ))}
        </div>
      </InnerBlock>
      <InnerCTA heading="Talk to us." body="A thirty-minute call with an engineer, not a salesperson." />
    </div>
  );
}
